import React from 'react';
import PropTypes from 'prop-types';
import HeaderLinkDisplay from '../../forms/helpers/header-link-display';

function SSOFormHeader({
    linkCallBackUrl,
    secondLinkCallBackUrl,
    headerTitle,
    headerSubtitle,
    headerMessage,
    headerLinkText,
    headerSecondMessage,
    headerSecondLinkText,
    messageOnNewRow,
    displaySecondMessageAndLink
}) {

    function getClassName() {
        if (!messageOnNewRow) {
            return 'flx flx-justify-space-between flx-items-center mb-sm';
        }

        return '';
    }

    return (
        <div className={getClassName()}>
            <h4 className="title">{headerTitle}</h4>
            {headerSubtitle ? <p>{headerSubtitle}</p> : null}
            <div className='fs-14'>
                <HeaderLinkDisplay headerMessage={headerMessage} headerLink={linkCallBackUrl} headerLinkText={headerLinkText}></HeaderLinkDisplay>
                {displaySecondMessageAndLink ?
                    <HeaderLinkDisplay headerMessage={headerSecondMessage} headerLink={secondLinkCallBackUrl} headerLinkText={headerSecondLinkText}></HeaderLinkDisplay>
                    : null
                }
            </div>
        </div>
    );
}

SSOFormHeader.propTypes = {
    headerTitle: PropTypes.string.isRequired,
    headerSubtitle: PropTypes.string,
    linkCallBackUrl: PropTypes.func,
    secondLinkCallBackUrl: PropTypes.func,
    headerMessage: PropTypes.string,
    headerLinkText: PropTypes.string,
    headerSecondMessage: PropTypes.string,
    headerSecondLinkText: PropTypes.string,
    messageOnNewRow: PropTypes.bool,
    displaySecondMessageAndLink: PropTypes.bool
};

export default SSOFormHeader;
